
import Fancybox from '../../../src/js/shared/fancybox';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const banner = {

		init: function() {
			this.bannerPopup();
		},

		bannerPopup: function() {
			Fancybox.initializefancyboxPopup('.js-popup-trigger', '.js-popup', 'popup-custom-class');
		},

	};

	banner.init();
});
